import { useRef } from 'react';
import Fila from 'components/corporatiu/Fila';
import Enllac from 'components/corporatiu/Enllac/Enllac';
import Icona from 'components/corporatiu/Icona/';
import Imatge from 'components/corporatiu/Imatge';
import { FreeMode, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './capcaleramarato.module.scss';

const CapcaleraMarato = (props) => {
    const { lang = 'none', seccio, urlLang = '', textActual = 'actual', textActiva, urlActiva, imatge } = props;
    const navigationPrev = useRef(null);
    const navigationNext = useRef(null);
    const idioma = lang === 'ca' || lang === 'none' ? '' : `${lang}/`;
    const HeaderTag = seccio === 'inici' ? 'h1' : 'div';
    const seccioSelected = seccio === 'totes' && textActual === textActiva ? 'actual' : seccio;
    const textEdicio = `La Marató ${textActiva ? textActiva : 'actual'}`;

    const textsCA = {
        actual: textEdicio,
        transparencia: 'Transparència',
        recerca: 'Recerca',
        totes: 'Totes les maratons',
        mes: 'Més',
        rsfacebook: 'Facebook de La Marató, obre en finestra nova',
        rsx: 'X de La Marató, obre en finestra nova',
        rsinstagram: 'Instagram de La Marató, obre en finestra nova',
        enllac: '/tv3/marato/'
    };
    const textsES = {
        actual: textEdicio,
        transparencia: 'Transparencia',
        recerca: 'Investigación',
        totes: 'Todas las maratones',
        mes: 'Más',
        rsfacebook: 'Facebook de La Marató, abre en ventana nueva',
        rsx: 'X de La Marató, abre en ventana nueva',
        rsinstagram: 'Instagram de La Marató, abre en ventana nueva',
        enllac: '/tv3/marato/es/'
    };
    const textsEN = {
        actual: textEdicio,
        transparencia: 'Transparency',
        recerca: 'Research',
        totes: 'All previous years',
        mes: 'More',
        rsfacebook: 'Facebook of La Marató, opens in new window',
        rsx: 'X of La Marató, opens in new window',
        rsinstagram: 'Instagram of La Marató, opens in new window',
        enllac: '/tv3/marato/en/'
    };

    const texts = lang === 'ca' || lang === 'none' ? textsCA : lang === 'es' ? textsES : textsEN;

    return (
        <div className={styles.capcaleraMarato}>
            <Fila tipus='fixed'>
                <Enllac href={texts.enllac} title='La Marató de 3cat' className={styles.linkCapcalera}>
                    <div className={styles.capcalera}>
                        <HeaderTag className={styles.titol}>
                            <div className={styles.logo}>
                                <Imatge
                                    src='https://statics.3cat.cat/recursos/marato/img/logos/logo-fundacio30_monocrom_W.svg'
                                    loading='lazy'
                                    alt='Fundació La Marató de 3Cat'
                                    width={218}
                                    height={63}
                                />
                            </div>
                        </HeaderTag>
                        {imatge && (
                            <div className={styles.eslogan}>
                                <Imatge
                                    src={imatge}
                                    loading='lazy'
                                    alt="Eslògan de La Marató d'enguany"
                                    width={246}
                                    height={114}
                                />
                            </div>
                        )}
                    </div>
                </Enllac>
            </Fila>

            <div className={styles.menuWrapper}>
                <Fila tipus='fixed'>
                    <Swiper
                        modules={[Navigation, FreeMode]}
                        className={styles.menu}
                        slidesPerView={'auto'}
                        freeMode={true}
                        tag='div'
                        wrapperTag='ul'
                        navigation={{ prevEl: navigationPrev.current, nextEl: navigationNext.current }}
                        onBeforeInit={(swiper) => {
                            swiper.params.navigation.prevEl = navigationPrev.current;
                            swiper.params.navigation.nextEl = navigationNext.current;
                        }}
                    >
                        <SwiperSlide
                            tag='li'
                            className={`${styles.mainOption} ${seccioSelected === 'actual' ? styles.selected : ''}`}
                        >
                            <Enllac href={`/tv3/marato/${idioma}${urlActiva ? urlActiva : ''}`}>{texts.actual}</Enllac>
                        </SwiperSlide>
                        <SwiperSlide
                            tag='li'
                            className={`${styles.mainOption} ${seccioSelected === 'transparencia' ? styles.selected : ''}`}
                        >
                            <Enllac href={`/tv3/marato/${idioma}fundacio/`}>{texts.transparencia}</Enllac>
                        </SwiperSlide>
                        <SwiperSlide
                            tag='li'
                            className={`${styles.mainOption} ${seccioSelected === 'recerca' ? styles.selected : ''}`}
                        >
                            <Enllac href={`/tv3/marato/${idioma}recerca/`}>{texts.recerca}</Enllac>
                        </SwiperSlide>
                        <SwiperSlide
                            tag='li'
                            className={`${styles.mainOption} ${seccioSelected === 'totes' ? styles.selected : ''}`}
                        >
                            <Enllac href={`/tv3/marato/${idioma}totes-maratons/`}>{texts.totes}</Enllac>
                        </SwiperSlide>
                        {(lang === 'ca' || lang === 'none') && (
                            <SwiperSlide
                                tag='li'
                                className={`${styles.mainOption} ${seccioSelected === 'mes' ? styles.selected : ''}`}
                            >
                                <Enllac href={`/tv3/marato/mes/`}>{texts.mes}</Enllac>
                            </SwiperSlide>
                        )}
                        {lang !== 'none' && (
                            <SwiperSlide
                                tag='li'
                                className={`${styles.langOption} ${lang === 'ca' ? styles.selected : ''} ${styles.first}`}
                            >
                                <Enllac
                                    href={`/tv3/marato/${urlLang}`}
                                    hrefLang={lang !== 'ca' ? 'ca' : undefined}
                                    rel={lang !== 'ca' ? 'alternate' : undefined}
                                >
                                    CAT
                                </Enllac>
                            </SwiperSlide>
                        )}
                        {lang !== 'none' && (
                            <SwiperSlide tag='li' className={`${styles.langOption} ${lang === 'es' ? styles.selected : ''}`}>
                                <Enllac
                                    href={`/tv3/marato/es/${urlLang}`}
                                    hrefLang={lang !== 'es' ? 'es' : undefined}
                                    rel={lang !== 'es' ? 'alternate' : undefined}
                                >
                                    CAST
                                </Enllac>
                            </SwiperSlide>
                        )}
                        {lang !== 'none' && (
                            <SwiperSlide tag='li' className={`${styles.langOption} ${lang === 'en' ? styles.selected : ''}`}>
                                <Enllac
                                    href={`/tv3/marato/en/${urlLang}`}
                                    hrefLang={lang !== 'en' ? 'en' : undefined}
                                    rel={lang !== 'en' ? 'alternate' : undefined}
                                >
                                    ENG
                                </Enllac>
                            </SwiperSlide>
                        )}

                        <SwiperSlide tag='li' className={`${styles.mainOption} ${lang !== 'none' ? ' ' + styles.first : ''}`}>
                            <Enllac href='https://www.facebook.com/lamarato' novaFinestra={true} title={texts.rsfacebook}>
                                <Icona icona='facebook' alt='Facebook' isBlanc='true' className={styles.socialIcon} />
                            </Enllac>
                        </SwiperSlide>
                        <SwiperSlide tag='li' className={styles.mainOption}>
                            <Enllac href='https://x.com/la_marato' novaFinestra={true} title={texts.rsx}>
                                <Icona icona='x' alt='X' isBlanc='true' className={styles.socialIcon} />
                            </Enllac>
                        </SwiperSlide>
                        <SwiperSlide tag='li' className={styles.mainOption}>
                            <Enllac href='https://www.instagram.com/lamarato3cat/' novaFinestra={true} title={texts.rsinstagram}>
                                <Icona icona='instagram' alt='Instagram' isBlanc='true' className={styles.socialIcon} />
                            </Enllac>
                        </SwiperSlide>
                        <div className={styles.fletxes}>
                            <button ref={navigationPrev} className={styles.anterior}>
                                <Icona
                                    icona='fletxa_simple_esquerra'
                                    isBlanc={true}
                                    alt='Anterior'
                                    mida={24}
                                    inline={true}
                                    tabIndex={0}
                                />
                            </button>
                            <button ref={navigationNext} className={styles.seguent}>
                                <Icona
                                    icona='fletxa_simple_dreta'
                                    isBlanc={true}
                                    alt='Següent'
                                    mida={24}
                                    inline={true}
                                    tabIndex={0}
                                />
                            </button>
                        </div>
                    </Swiper>
                </Fila>
            </div>
        </div>
    );
};

export default CapcaleraMarato;
